var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPopcorn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "-88 1 511 511.99988",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb211"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 28.3118147864,
    x2: 113.3822576146,
    xlinkHref: "#a",
    y1: 94.0893302918,
    y2: 179.1598735122
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb211",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1624,
    stopColor: "#ffaa14",
    stopOpacity: 0.160784
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4095,
    stopColor: "#ff951e",
    stopOpacity: 0.407843
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    stopColor: "#ff732d",
    stopOpacity: 0.709804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4b3e"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 30.5797749766,
    x2: 19.5390423894,
    xlinkHref: "#c",
    y1: 126.4273645792,
    y2: 58.2897729484
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 38.3246316378,
    x2: 77.1251126236,
    xlinkHref: "#c",
    y1: 97.7083687096,
    y2: 62.693276017
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 57.119155792,
    x2: 110.2024350718,
    xlinkHref: "#c",
    y1: 109.4552600316,
    y2: 162.5385393114
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 100.5701046584,
    x2: 185.6405474866,
    xlinkHref: "#a",
    y1: 110.1467615052,
    y2: 195.2172043334
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 102.8380648486,
    x2: 91.7973322614,
    xlinkHref: "#c",
    y1: 142.4847957926,
    y2: 74.3470033774
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 110.5829215098,
    x2: 149.3835028878,
    xlinkHref: "#c",
    y1: 113.765799923,
    y2: 78.7507072304
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 129.3773452718,
    x2: 182.4607249438,
    xlinkHref: "#c",
    y1: 125.5125908528,
    y2: 178.5959705248
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 159.6046335542,
    x2: 244.6751767746,
    xlinkHref: "#a",
    y1: 91.2557604468,
    y2: 176.326203275
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 164.6008521716,
    x2: 151.0883632282,
    xlinkHref: "#c",
    y1: 127.5547689852,
    y2: 91.2401996558
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 189.5010291454,
    x2: 171.0519545514,
    xlinkHref: "#c",
    y1: 109.4598780728,
    y2: 66.5038627524
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 80.7345133902,
    x2: 165.8049562184,
    xlinkHref: "#a",
    y1: 61.8028975952,
    y2: 146.8734408156
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 83.0024735804,
    x2: 71.9617409932,
    xlinkHref: "#c",
    y1: 94.1409318826,
    y2: 26.0033402518
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 90.7473302416,
    x2: 129.5478112274,
    xlinkHref: "#c",
    y1: 65.421936013,
    y2: 30.4069437126
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 122.0680903664,
    x2: 144.870471929,
    xlinkHref: "#c",
    y1: 85.4498787364,
    y2: 155.1236718116
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 207.2232642114,
    x2: 292.2938074318,
    xlinkHref: "#a",
    y1: 40.3144491462,
    y2: 125.3848919744
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 209.4913247938,
    x2: 198.4504918144,
    xlinkHref: "#c",
    y1: 72.6524834336,
    y2: 4.5146910184
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 217.2360810628,
    x2: 256.0366624408,
    xlinkHref: "#c",
    y1: 43.933487564,
    y2: 8.9183948714
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 236.030605217,
    x2: 289.113984889,
    xlinkHref: "#c",
    y1: 55.6802784938,
    y2: 108.7636581658
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientTransform: "matrix(.769506 .644718 -.644718 .769506 -20.916634 -160.391375)",
    gradientUnits: "userSpaceOnUse",
    x1: 251.7633,
    x2: 336.504,
    xlinkHref: "#a",
    y1: 21.5766,
    y2: 106.3173
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientTransform: "matrix(.769506 .644718 -.644718 .769506 -20.916634 -160.391375)",
    gradientUnits: "userSpaceOnUse",
    x1: 254.023,
    x2: 243.025,
    xlinkHref: "#c",
    y1: 53.7896,
    y2: -14.0839
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientTransform: "matrix(.769506 .644718 -.644718 .769506 -20.916634 -160.391375)",
    gradientUnits: "userSpaceOnUse",
    x1: 261.7372,
    x2: 300.3873,
    xlinkHref: "#c",
    y1: 25.1817,
    y2: -9.6976
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: 172.3230201956,
    x2: 156.2768329086,
    y1: 66.4064823184,
    y2: -11.290253812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb211",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1617,
    stopColor: "#ffaa14",
    stopOpacity: 0.14902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4078,
    stopColor: "#ff951e",
    stopOpacity: 0.376471
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#ff732d",
    stopOpacity: 0.654902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8348,
    stopColor: "#ff6234",
    stopOpacity: 0.772549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4b3e"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    gradientTransform: "matrix(.769506 .644718 -.644718 .769506 -20.916634 -160.391375)",
    gradientUnits: "userSpaceOnUse",
    x1: 385.6358,
    x2: 470.3764,
    xlinkHref: "#a",
    y1: -12.0276,
    y2: 72.7131
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientTransform: "matrix(.769506 .644718 -.644718 .769506 -20.916634 -160.391375)",
    gradientUnits: "userSpaceOnUse",
    x1: 387.8954,
    x2: 376.8975,
    xlinkHref: "#c",
    y1: 20.1853,
    y2: -47.6881
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientTransform: "matrix(.769506 .644718 -.644718 .769506 -20.916634 -160.391375)",
    gradientUnits: "userSpaceOnUse",
    x1: 395.6097,
    x2: 434.2597,
    xlinkHref: "#c",
    y1: -8.4226,
    y2: -43.3018
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientTransform: "matrix(.769506 .644718 -.644718 .769506 -20.916634 -160.391375)",
    gradientUnits: "userSpaceOnUse",
    x1: 414.3318,
    x2: 467.2094,
    xlinkHref: "#c",
    y1: 3.2783,
    y2: 56.1558
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 220.5283428696,
    x2: 305.5987856978,
    xlinkHref: "#a",
    y1: 108.7299263866,
    y2: 193.8003692148
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 222.7963030598,
    x2: 211.7555704726,
    xlinkHref: "#c",
    y1: 141.067960674,
    y2: 72.9301682588
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 230.541159721,
    x2: 269.3416407068,
    xlinkHref: "#c",
    y1: 112.3489648044,
    y2: 77.3338721118
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 249.335583483,
    x2: 302.418963155,
    xlinkHref: "#c",
    y1: 124.0957557342,
    y2: 177.1791354062
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4b3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0286,
    stopColor: "#fb4a3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3327,
    stopColor: "#d03e25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6067,
    stopColor: "#b13515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8384,
    stopColor: "#9e300b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#972e07"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 109.281437029,
    x2: 488.1724421866,
    xlinkHref: "#H",
    y1: 147.911696948,
    y2: 526.8026017134
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientUnits: "userSpaceOnUse",
    x1: -6.2812290974,
    x2: 381.2655915442,
    xlinkHref: "#H",
    y1: 254.6629396804,
    y2: 642.209760322
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2e9dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6623,
    stopColor: "#e3c7b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dab49d"
  }))), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientUnits: "userSpaceOnUse",
    x1: 20.2299415098,
    x2: 406.9248339422,
    xlinkHref: "#K",
    y1: 231.2921374814,
    y2: 617.9869295216
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 79.5107324722,
    x2: 468.1385763234,
    xlinkHref: "#K",
    y1: 174.1212893864,
    y2: 562.7491332376
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dab49d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2054,
    stopColor: "#d8b198",
    stopOpacity: 0.203922
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4642,
    stopColor: "#d3a788",
    stopOpacity: 0.462745
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7504,
    stopColor: "#ca976e",
    stopOpacity: 0.74902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c08552"
  }))), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 290.182659858,
    x2: 32.177215663,
    xlinkHref: "#N",
    y1: 357.6060050902,
    y2: 99.6006612874
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 324.9723720616,
    x2: 66.967630612,
    xlinkHref: "#N",
    y1: 322.8161924944,
    y2: 64.8114510448
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientUnits: "userSpaceOnUse",
    x1: 49.8120091228,
    x2: 437.4070180204,
    xlinkHref: "#H",
    y1: 202.8989143008,
    y2: 590.4941239828
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972e07",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#582707"
  }))), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 269.2361285046,
    x2: 269.2361285046,
    xlinkHref: "#R",
    y1: 438.0495722048,
    y2: 542.7990948614
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    gradientUnits: "userSpaceOnUse",
    x1: 66.1943094954,
    x2: 66.1943094954,
    xlinkHref: "#R",
    y1: 438.0495722048,
    y2: 542.7990948614
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    gradientUnits: "userSpaceOnUse",
    x1: 114.6280244244,
    x2: 114.6280244244,
    xlinkHref: "#N",
    y1: 422.594795368,
    y2: 513.6065489844
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    gradientUnits: "userSpaceOnUse",
    x1: 220.8025139678,
    x2: 220.8025139678,
    xlinkHref: "#N",
    y1: 422.594795368,
    y2: 513.6065489844
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    gradientUnits: "userSpaceOnUse",
    x1: 167.715219,
    x2: 167.715219,
    xlinkHref: "#R",
    y1: 438.0495722048,
    y2: 542.7990948614
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    gradientUnits: "userSpaceOnUse",
    x1: 313.4598965266,
    x2: -6.4729781994,
    xlinkHref: "#R",
    y1: 279.3492812682,
    y2: -40.5835934578
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    gradientUnits: "userSpaceOnUse",
    x1: 245.2068538658,
    x2: -74.7255188992,
    xlinkHref: "#R",
    y1: 347.6020227524,
    y2: 27.6696499874
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    gradientUnits: "userSpaceOnUse",
    x1: 279.6679823988,
    x2: -40.2638884052,
    xlinkHref: "#R",
    y1: 313.141195396,
    y2: -6.790675408
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m75.066406 93.027344c.210938-1.359375.320313-2.757813.320313-4.175782 0-15.046874-12.199219-27.246093-27.246094-27.246093s-27.246094 12.199219-27.246094 27.246093c0 1.917969.199219 3.789063.578125 5.597657-11.070312 3.460937-19.105468 13.796875-19.105468 26.007812 0 15.046875 12.199218 27.246094 27.246093 27.246094 6.257813 0 12.019531-2.113281 16.617188-5.660156 5.648437 7.984375 14.953125 13.203125 25.480469 13.203125 17.230468 0 31.199218-13.96875 31.199218-31.199219 0-16.097656-12.191406-29.34375-27.84375-31.019531zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.859375 120.457031c0 15.046875-12.199219 27.246094-27.246094 27.246094s-27.246093-12.199219-27.246093-27.246094 12.199218-27.246093 27.246093-27.246093 27.246094 12.199218 27.246094 27.246093zm0 0",
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m75.386719 88.851562c0 15.046876-12.199219 27.246094-27.246094 27.246094s-27.246094-12.199218-27.246094-27.246094c0-15.046874 12.199219-27.246093 27.246094-27.246093s27.246094 12.199219 27.246094 27.246093zm0 0",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m102.910156 124.046875c0 17.230469-13.96875 31.199219-31.199218 31.199219-17.230469 0-31.199219-13.96875-31.199219-31.199219s13.96875-31.199219 31.199219-31.199219c17.230468 0 31.199218 13.96875 31.199218 31.199219zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m147.324219 109.085938c.210937-1.363282.320312-2.757813.320312-4.179688 0-15.046875-12.199219-27.246094-27.246093-27.246094-15.046876 0-27.246094 12.199219-27.246094 27.246094 0 1.917969.199218 3.792969.578125 5.597656-11.070313 3.464844-19.105469 13.796875-19.105469 26.011719 0 15.046875 12.199219 27.246094 27.246094 27.246094 6.257812 0 12.019531-2.117188 16.617187-5.664063 5.652344 7.988282 14.953125 13.207032 25.480469 13.207032 17.230469 0 31.199219-13.96875 31.199219-31.199219 0-16.097657-12.191407-29.34375-27.84375-31.019531zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m129.117188 136.515625c0 15.046875-12.199219 27.246094-27.246094 27.246094s-27.246094-12.199219-27.246094-27.246094c0-15.050781 12.199219-27.246094 27.246094-27.246094s27.246094 12.195313 27.246094 27.246094zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m147.644531 104.90625c0 15.050781-12.199219 27.246094-27.246093 27.246094-15.046876 0-27.246094-12.195313-27.246094-27.246094 0-15.046875 12.199218-27.246094 27.246094-27.246094 15.046874 0 27.246093 12.199219 27.246093 27.246094zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m175.167969 140.105469c0 17.230469-13.96875 31.199219-31.199219 31.199219s-31.199219-13.96875-31.199219-31.199219c0-17.234375 13.96875-31.203125 31.199219-31.203125s31.199219 13.96875 31.199219 31.203125zm0 0",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m206.359375 90.195312c.210937-1.363281.320313-2.757812.320313-4.179687 0-15.046875-12.199219-27.246094-27.246094-27.246094s-27.246094 12.199219-27.246094 27.246094c0 1.917969.199219 3.792969.578125 5.597656-11.070313 3.464844-19.105469 13.796875-19.105469 26.011719 0 15.046875 12.199219 27.246094 27.246094 27.246094 6.257812 0 12.019531-2.117188 16.617188-5.664063 5.648437 7.988281 14.953124 13.207031 25.480468 13.207031 17.230469 0 31.199219-13.96875 31.199219-31.199218 0-16.097656-12.191406-29.34375-27.84375-31.019532zm0 0",
    fill: "url(#k)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m188.152344 117.621094c0 15.050781-12.199219 27.246094-27.246094 27.246094s-27.246094-12.195313-27.246094-27.246094c0-15.046875 12.199219-27.246094 27.246094-27.246094s27.246094 12.199219 27.246094 27.246094zm0 0",
    fill: "url(#l)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m206.679688 86.015625c0 15.050781-12.199219 27.246094-27.246094 27.246094s-27.246094-12.195313-27.246094-27.246094c0-15.046875 12.199219-27.246094 27.246094-27.246094s27.246094 12.199219 27.246094 27.246094zm0 0",
    fill: "url(#m)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m127.488281 60.742188c.210938-1.363282.320313-2.757813.320313-4.175782 0-15.050781-12.199219-27.246094-27.246094-27.246094s-27.246094 12.195313-27.246094 27.246094c0 1.917969.199219 3.789063.578125 5.59375-11.070312 3.464844-19.105469 13.796875-19.105469 26.011719 0 15.046875 12.199219 27.246094 27.246094 27.246094 6.257813 0 12.019532-2.117188 16.617188-5.664063 5.652344 7.988282 14.953125 13.207032 25.480468 13.207032 17.230469 0 31.199219-13.96875 31.199219-31.199219 0-16.097657-12.191406-29.34375-27.84375-31.019531zm0 0",
    fill: "url(#n)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m109.28125 88.171875c0 15.046875-12.199219 27.246094-27.246094 27.246094s-27.246094-12.199219-27.246094-27.246094c0-15.050781 12.199219-27.246094 27.246094-27.246094s27.246094 12.195313 27.246094 27.246094zm0 0",
    fill: "url(#o)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m127.808594 56.566406c0 15.046875-12.199219 27.246094-27.246094 27.246094s-27.246094-12.199219-27.246094-27.246094c0-15.050781 12.199219-27.246094 27.246094-27.246094s27.246094 12.195313 27.246094 27.246094zm0 0",
    fill: "url(#p)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m155.332031 91.761719c0 17.230469-13.96875 31.199219-31.199219 31.199219-17.230468 0-31.199218-13.96875-31.199218-31.199219 0-17.234375 13.96875-31.203125 31.199218-31.203125 17.230469 0 31.199219 13.96875 31.199219 31.203125zm0 0",
    fill: "url(#q)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m253.976562 39.253906c.210938-1.363281.320313-2.757812.320313-4.179687 0-15.046875-12.199219-27.246094-27.246094-27.246094s-27.246093 12.199219-27.246093 27.246094c0 1.921875.199218 3.792969.578124 5.597656-11.070312 3.464844-19.105468 13.796875-19.105468 26.011719 0 15.046875 12.199218 27.246094 27.246094 27.246094 6.257812 0 12.019531-2.117188 16.617187-5.660157 5.652344 7.984375 14.953125 13.203125 25.480469 13.203125 17.230468 0 31.199218-13.96875 31.199218-31.199218 0-16.097657-12.191406-29.34375-27.84375-31.019532zm0 0",
    fill: "url(#r)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m235.769531 66.679688c0 15.050781-12.199219 27.25-27.246093 27.25-15.046876 0-27.246094-12.199219-27.246094-27.25 0-15.046876 12.199218-27.246094 27.246094-27.246094 15.046874 0 27.246093 12.199218 27.246093 27.246094zm0 0",
    fill: "url(#s)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m254.296875 35.074219c0 15.050781-12.199219 27.25-27.246094 27.25s-27.246093-12.199219-27.246093-27.25c0-15.046875 12.199218-27.246094 27.246093-27.246094s27.246094 12.199219 27.246094 27.246094zm0 0",
    fill: "url(#t)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m281.820312 70.269531c0 17.234375-13.96875 31.203125-31.199218 31.203125-17.230469 0-31.199219-13.96875-31.199219-31.203125 0-17.230469 13.96875-31.199219 31.199219-31.199219 17.230468 0 31.199218 13.96875 31.199218 31.199219zm0 0",
    fill: "url(#u)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m195.425781 47.742188c1.035157-.910157 2.015625-1.910157 2.929688-2.996094 9.664062-11.535156 8.144531-28.71875-3.386719-38.382813-11.535156-9.664062-28.71875-8.148437-38.382812 3.386719-1.234376 1.46875-2.28125 3.035156-3.152344 4.660156-10.710938-4.457031-23.503906-1.695312-31.347656 7.667969-9.664063 11.535156-8.148438 28.71875 3.386718 38.382813 4.796875 4.019531 10.570313 6.097656 16.375 6.332031-.796875 9.75 2.980469 19.726562 11.050782 26.484375 13.207031 11.066406 32.886718 9.332031 43.953124-3.878906 10.335938-12.335938 9.496094-30.320313-1.425781-41.65625zm0 0",
    fill: "url(#v)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m170.214844 39.574219c0 15.050781-12.199219 27.246093-27.246094 27.246093s-27.246094-12.195312-27.246094-27.246093c0-15.046875 12.199219-27.246094 27.246094-27.246094s27.246094 12.199219 27.246094 27.246094zm0 0",
    fill: "url(#w)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m204.714844 27.246094c0 15.050781-12.199219 27.246094-27.246094 27.246094s-27.246094-12.195313-27.246094-27.246094c0-15.046875 12.199219-27.246094 27.246094-27.246094s27.246094 12.199219 27.246094 27.246094zm0 0",
    fill: "url(#x)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m204.132812 69.363281c0 17.230469-13.96875 31.199219-31.199218 31.199219-17.230469 0-31.199219-13.96875-31.199219-31.199219s13.96875-31.199219 31.199219-31.199219c17.230468 0 31.199218 13.96875 31.199218 31.199219zm0 0",
    fill: "url(#y)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m320.105469 108.195312c1.035156-.910156 2.015625-1.910156 2.929687-3 9.664063-11.535156 8.148438-28.71875-3.386718-38.382812-11.535157-9.664062-28.71875-8.144531-38.382813 3.386719-1.234375 1.472656-2.28125 3.035156-3.152344 4.664062-10.710937-4.457031-23.503906-1.695312-31.347656 7.664063-9.664063 11.535156-8.148437 28.722656 3.386719 38.386718 4.796875 4.015626 10.570312 6.09375 16.375 6.332032-.796875 9.75 2.980468 19.722656 11.050781 26.484375 13.207031 11.066406 32.886719 9.328125 43.953125-3.878907 10.335938-12.339843 9.496094-30.320312-1.425781-41.65625zm0 0",
    fill: "url(#z)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m294.898438 100.027344c0 15.046875-12.199219 27.246094-27.246094 27.246094-15.050782 0-27.25-12.199219-27.25-27.246094s12.199218-27.246094 27.25-27.246094c15.046875 0 27.246094 12.199219 27.246094 27.246094zm0 0",
    fill: "url(#A)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m329.394531 87.699219c0 15.046875-12.199219 27.246093-27.246093 27.246093-15.046876 0-27.246094-12.199218-27.246094-27.246093s12.199218-27.246094 27.246094-27.246094c15.046874 0 27.246093 12.199219 27.246093 27.246094zm0 0",
    fill: "url(#B)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m328.8125 129.8125c0 17.234375-13.964844 31.203125-31.199219 31.203125-17.230469 0-31.199219-13.96875-31.199219-31.203125 0-17.230469 13.96875-31.199219 31.199219-31.199219 17.234375 0 31.199219 13.96875 31.199219 31.199219zm0 0",
    fill: "url(#C)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m267.28125 107.667969c.210938-1.359375.320312-2.757813.320312-4.175781 0-15.050782-12.199218-27.246094-27.246093-27.246094s-27.246094 12.195312-27.246094 27.246094c0 1.917968.199219 3.789062.578125 5.597656-11.070312 3.460937-19.105469 13.796875-19.105469 26.007812 0 15.046875 12.199219 27.246094 27.246094 27.246094 6.257813 0 12.019531-2.113281 16.617187-5.660156 5.652344 7.984375 14.953126 13.203125 25.480469 13.203125 17.234375 0 31.199219-13.96875 31.199219-31.199219 0-16.097656-12.191406-29.34375-27.84375-31.019531zm0 0",
    fill: "url(#D)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m249.074219 135.097656c0 15.046875-12.199219 27.246094-27.246094 27.246094s-27.246094-12.199219-27.246094-27.246094c0-15.050781 12.199219-27.246094 27.246094-27.246094s27.246094 12.195313 27.246094 27.246094zm0 0",
    fill: "url(#E)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m267.601562 103.492188c0 15.046874-12.199218 27.246093-27.246093 27.246093s-27.246094-12.199219-27.246094-27.246093c0-15.050782 12.199219-27.246094 27.246094-27.246094s27.246093 12.195312 27.246093 27.246094zm0 0",
    fill: "url(#F)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m295.125 138.6875c0 17.230469-13.96875 31.199219-31.199219 31.199219s-31.199219-13.96875-31.199219-31.199219 13.96875-31.199219 31.199219-31.199219 31.199219 13.96875 31.199219 31.199219zm0 0",
    fill: "url(#G)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m273.65625 148.574219-35.042969 363.417969h18.902344c13.019531 0 24.089844-9.503907 26.058594-22.375l50.996093-333.453126c2.84375-18.59375-11.542968-35.347656-30.351562-35.347656-15.8125 0-29.042969 12.015625-30.5625 27.757813zm0 0",
    fill: "url(#I)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m.859375 156.164062 50.996094 333.453126c1.96875 12.871093 13.039062 22.375 26.0625 22.375h18.898437l-35.042968-363.417969c-1.519532-15.742188-14.746094-27.757813-30.5625-27.757813-18.808594 0-33.195313 16.753906-30.351563 35.347656zm0 0",
    fill: "url(#J)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m62.683594 158.007812 34.132812 353.984376h48.050782l-11.136719-358.292969c-.566407-18.324219-15.585938-32.882813-33.914063-32.882813h-3.355468c-20.03125 0-35.703126 17.257813-33.777344 37.191406zm0 0",
    fill: "url(#L)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m201.699219 153.699219-11.136719 358.296875h48.050781l34.136719-353.984375c1.921875-19.9375-13.75-37.191407-33.777344-37.191407h-3.355468c-18.332032-.003906-33.347657 14.554688-33.917969 32.878907zm0 0",
    fill: "url(#M)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m137.195312 265.097656-71.039062-71.039062-3.472656-36.050782c-1.925782-19.9375 13.742187-37.195312 33.777344-37.195312h3.351562c18.332031 0 33.351562 14.558594 33.925781 32.882812zm0 0",
    fill: "url(#O)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m272.746094 158.007812-21.335938 221.308594-55.011718-55.015625 5.296874-170.605469c.570313-18.324218 15.589844-32.882812 33.925782-32.882812h3.347656c20.035156 0 35.707031 17.257812 33.777344 37.195312zm0 0",
    fill: "url(#P)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m133.796875 155.804688 11.070313 356.191406h45.695312l11.070312-356.191406c.59375-19.144532-14.765624-34.988282-33.917968-34.988282s-34.511719 15.84375-33.917969 34.988282zm0 0",
    fill: "url(#Q)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m299.863281 383.101562-16.285156 106.511719c-1.972656 12.878907-13.046875 22.386719-26.0625 22.386719h-18.90625l12.433594-128.898438zm0 0",
    fill: "url(#S)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m96.820312 512h-18.90625c-13.011718 0-24.089843-9.507812-26.058593-22.386719l-16.285157-106.511719h48.816407zm0 0",
    fill: "url(#T)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m144.867188 512h-48.046876l-12.433593-128.898438h56.472656zm0 0",
    fill: "url(#U)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m251.042969 383.101562-12.433594 128.898438h-48.046875l4.007812-128.898438zm0 0",
    fill: "url(#V)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m194.570312 383.101562-4.007812 128.898438h-45.695312l-4.007813-128.898438zm0 0",
    fill: "url(#W)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m334.570312 156.160156-40.632812 265.679688-42.539062-42.535156 22.253906-230.726563c.761718-7.875 4.449218-14.820313 9.925781-19.792969 5.476563-4.96875 12.730469-7.972656 20.640625-7.972656 18.804688 0 33.195312 16.753906 30.351562 35.347656zm0 0",
    fill: "url(#X)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m66.167969 194.070312-60.121094-60.121093c5.5-7.886719 14.636719-13.136719 25.164063-13.136719 15.816406 0 29.042968 12.015625 30.566406 27.765625zm0 0",
    fill: "url(#Y)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m201.628906 155.800781-5.230468 168.5-59.203126-59.203125-3.394531-109.296875c-.007812-.371093-.019531-.726562-.019531-1.085937 0-18.648438 15.152344-33.902344 33.933594-33.902344 19.152344 0 34.519531 15.847656 33.914062 34.988281zm0 0",
    fill: "url(#Z)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopcorn);
export default __webpack_public_path__ + "static/media/icon-popcorn.3eb38f5611b9d2e3d421973f721f54c2.svg";
export { ForwardRef as ReactComponent };